import {useCallback, useEffect, useRef, useState} from 'react';
import {sendRaw} from '../utils/websocket';

/** Explicit ephemeral processing of this active composer only; no storage. */
export function useSpeculativeTyping(roomId, text, connected, available = false) {
  const [enabled, setEnabled] = useState(false);
  const latest = useRef(text);
  latest.current = text;
  const timer = useRef(null);
  const revision = useRef(0);
  const active = useRef(false);
  const beforeSubmit = useCallback(() => {
    clearTimeout(timer.current);
    timer.current = null;
  }, []);
  const cancel = useCallback(() => {
    beforeSubmit();
    if (active.current) sendRaw({type:'response_draft_cancel', room_id:roomId});
    active.current = false;
  }, [beforeSubmit, roomId]);

  useEffect(() => {
    setEnabled(false);
    return cancel;
  }, [roomId, cancel]);

  useEffect(() => {
    if (!connected || !available || !enabled || !text.trim() || text.length > 2000) {
      cancel();
      return;
    }
    // Keep the first deadline while keys continue arriving: this is coalescing,
    // not a debounce that waits for the user to finish typing.
    if (timer.current === null) {
      timer.current = setTimeout(() => {
        timer.current = null;
        revision.current += 1;
        active.current = sendRaw({type:'response_draft_update', room_id:roomId,
          text:latest.current, revision:revision.current});
      }, 500);
    }
  }, [available, enabled, connected, roomId, text, cancel]);

  return {available, enabled, setEnabled, beforeSubmit};
}
